import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// import { store, persistor } from './store/reducers/cartReducer';
import { store, persistor } from './store/reducers/cartReducer';
import './index.scss';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { PersistGate } from 'redux-persist/integration/react';

const initStore = store;

ReactDOM.render(
  <Provider store={initStore}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
